import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './Problem.css';

// `ns` is the locale key holding eyebrow, heading, items and an optional
// bridge; the items render in the order the locale file lists them. The home
// page uses `problem`, each service page its own set of pains.
function Problem({ ns = 'problem', id = 'problem' }) {
  const { t, i18n } = useTranslation();
  const items = Object.keys(t(`${ns}.items`, { returnObjects: true }) || {});

  return (
    <section id={id} className="problem">
      <p className="section-eyebrow">{t(`${ns}.eyebrow`)}</p>
      <h2 className="problem-title">
        <Trans i18nKey={`${ns}.heading`} components={{ em: <em /> }} />
      </h2>

      <div className="problem-grid">
        {items.map((key, idx) => (
          <article key={key} className="problem-item">
            <span className="problem-num">{String(idx + 1).padStart(2, '0')}</span>
            <h3 className="problem-item-title">{t(`${ns}.items.${key}.title`)}</h3>
            <p className="problem-item-body">{t(`${ns}.items.${key}.body`)}</p>
          </article>
        ))}
      </div>

      {i18n.exists(`${ns}.bridge`) && <p className="problem-bridge">{t(`${ns}.bridge`)}</p>}
    </section>
  );
}

export default Problem;
